import { render } from "./DeliveryCostInformationModal.vue?vue&type=template&id=4d4c4bd1&scoped=true"
import script from "./DeliveryCostInformationModal.vue?vue&type=script&lang=js"
export * from "./DeliveryCostInformationModal.vue?vue&type=script&lang=js"

import "./DeliveryCostInformationModal.vue?vue&type=style&index=0&id=4d4c4bd1&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d4c4bd1"],['__file',"src/components/shared/Modals/DeliveryCostInformationModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4d4c4bd1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4d4c4bd1', __exports__)) {
    api.reload('4d4c4bd1', __exports__)
  }
  
  module.hot.accept("./DeliveryCostInformationModal.vue?vue&type=template&id=4d4c4bd1&scoped=true", () => {
    api.rerender('4d4c4bd1', render)
  })

}


export default __exports__